import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { DropDownInputIcon } from '../svgIcon';

function SelectBox(props) {
  const changes = (event, newValue) => {
    props?.onchange(props?.name, newValue);
  };

  // Disable the option if it is selected in any row

  const getOptionDisabled = (option) => {
    if (option.id === 'none') {
      return false;
    }
    return props?.selectedOptions?.some((selectedOption) => selectedOption?.id === option?.id);
  };

  return (
    <div className="input-black">
      {props?.label && (
        <label className="label" htmlFor={props?.name}>
          {props?.label}{props?.required && <span className="text-danger">*</span>}
        </label>
      )}
      <Autocomplete
        multiple={props?.multiple}
        value={props?.value}
        name={props?.name}
        onChange={changes}
        options={props?.lists}
        id={props?.id}
        popupIcon={<DropDownInputIcon />}
        disableClearable={props?.disableClearable}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        disabled={props?.disabled}
        getOptionDisabled={getOptionDisabled}
        sx={{
          '.MuiAutocomplete-input': { fontSize: '14px', fontFamily: 'Inter' },
          '.MuiOutlinedInput-root': {
            padding: props?.customPadding ? props?.customPadding : '2.5px 4.5px',
            height: '40px',
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#43B48D !important', // Change border color on hover
            },
          },
          '.MuiOutlinedInput-notchedOutline': {
            border: props?.border === false ? 'none !important' : '0.5px solid #CACACA !important',
            borderRadius: '6px !important',
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={props?.placeholder}
          />
        )}
        renderOption={(prop, option) => (
          <li {...prop}>
            <span id={option?.label}>{option?.label}</span>
          </li>
        )}
      />
    </div>
  );
}

SelectBox.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  lists: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ])),
  onchange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  border: PropTypes.bool,
  disableClearable: PropTypes.bool,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  selectedOptions: PropTypes.arrayOf(PropTypes.number),
  customPadding: PropTypes.string,
};
SelectBox.defaultProps = {
  multiple: false,
  label: '',
  value: '',
  lists: [],
  border: true,
  disableClearable: false,
  id: '',
  required: false,
  disabled: false,
  selectedOptions: [],
  customPadding: '',
};

export default SelectBox;
